export default __webpack_public_path__ + "static/media/Spotify_Green.cd66b8f6.png";